export default "__VITE_ASSET__6F3nE9Ys__"